import React, { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../SubscriptionAppButton';
interface ReleaseScheduleSwitchDialogProps {
  isOpen: boolean;
  frequencyCount: number;
  firstFrequencyLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
}
export function ReleaseScheduleSwitchDialog({
  isOpen,
  frequencyCount,
  firstFrequencyLabel,
  onCancel,
  onConfirm
}: ReleaseScheduleSwitchDialogProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onCancel]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-4141" data-mp="3uircerxgtwx3">
      <div className="absolute inset-0 bg-[#0F172A]/50" onClick={onCancel} aria-hidden="true" data-id="element-4142" data-mp="3uku035b5bdyn" />
      <div role="dialog" aria-modal="true" aria-labelledby="release-switch-title" className="relative w-full max-w-[460px] bg-white rounded-lg shadow-xl border border-[#E2E8F0]" data-id="element-4143" data-mp="3allr468ofvc">
        <div className="p-6" data-id="element-4144" data-mp="osn1nk6qczu4">
          <div className="flex items-start gap-3" data-id="element-4145" data-mp="ophewblkqa1k">
            <div className="p-2 bg-[#FEF3C7] rounded-lg flex-shrink-0" data-id="element-4146" data-mp="jr7kw4bl5fhj">
              <AlertTriangle className="w-5 h-5 text-[#D97706]" data-id="element-4147" data-mp="etebl2ezk5d1" />
            </div>
            <div data-id="element-4148" data-mp="arkfl7fqjpj7">
              <h2 id="release-switch-title" className="text-[16px] font-semibold text-[#0F172A]" data-id="element-4149" data-mp="as2mcy00xm5d">
                Replace frequencies with releases?
              </h2>
              <p className="text-[14px] text-[#64748B] mt-2" data-id="element-4150" data-mp="5yzowes4lsjw">
                On fixed release dates, each release sets when members are
                charged. This pack's {frequencyCount}{' '}
                {frequencyCount === 1 ? 'frequency' : 'frequencies'} will be
                replaced by a first release on 1 March, and you can add more.
              </p>
              {firstFrequencyLabel && <p className="text-[14px] text-[#64748B] mt-2" data-id="element-4151" data-mp="3j9gw8z4xoaip">
                  The discount and tier settings from{' '}
                  <span className="font-medium text-[#0F172A]" data-id="element-4152" data-mp="3dl3myy7myt48">
                    {firstFrequencyLabel}
                  </span>{' '}
                  carry over to the first release as a starting point.
                </p>}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-[#E2E8F0] bg-[#F8FAFC] rounded-b-lg" data-id="element-4153" data-mp="34mrn05kvqiz4">
          <Button variant="secondary" onClick={onCancel} data-id="element-4154" data-mp="3scm0mpd0wbkf">
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm} data-id="element-4155" data-mp="8a007cjmcvj">
            Replace frequencies
          </Button>
        </div>
      </div>
    </div>;
}